import { render } from "./DoctorDashboard.vue?vue&type=template&id=1a6bf14b&ts=true"
import script from "./DoctorDashboard.vue?vue&type=script&lang=ts"
export * from "./DoctorDashboard.vue?vue&type=script&lang=ts"

import "./DoctorDashboard.vue?vue&type=style&index=0&id=1a6bf14b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__